import React from 'react'
import Home from '../../home/Home'
import Hotel from '../../home/listings/hotel/Hotel'

const HotelView = () => {
  return (
        <>
        <Home />
        <Hotel />
        </>
  )
}

export default HotelView
